import React, { useState } from "react";
// import AWS from "aws-sdk";
// import axios from "axios";

// const UAMediaRemover = ({ onRemoveComplete }) => {
// Remove File (From Frontend & AWS S3)

const UARemoveFiles = () => {
  const [mediafiles, setMediaFiles] = useState([]);
  // Handle media upload
  const handleRemoveFile = async (fileKey) => {

    try {
          // await s3.deleteObject({ Bucket: "YOUR_BUCKET_NAME", Key: fileKey }).promise();
          setMediaFiles((prevFiles) => prevFiles.filter((file) => file.key !== fileKey));
          console.log(`File ${fileKey} removed successfully.`);
      } catch (error) {
          console.error("Error deleting file:", error);
      }
  };
};

export default UARemoveFiles;
